import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllCtaContextsTable from './Table';
//import NewItemModal from '../../../Modals/HomepageHeroItem/NewItemModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllCtaContextsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            items: [],
            searchValue: '',
        };

        this.itemQueryObject = {
            page: 1,
            limit: 30,
        };
    }
    
    componentDidMount() {
        this.loadItems();
    }

    onColumnSort = ( value ) => {
        if( this.itemQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.itemQueryObject.sort = value;
        this.itemQueryObject.page = 1;
        this.setState( {
            fetching: true,
            items: [],
        } );
        this.loadItems();
    }

    loadItems = () => {
        return this.props.getCtaContexts( this.itemQueryObject )
        .then( ( items ) => {
            this.itemQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.items = prevState.items.concat( items );
                return prevState;
            } );
            return items;
        } );
    }

    render() {
        const { fetching, items, searchValue } = this.state;
        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Action Items</h2>
                    <div className={ style.controls }>
                        <br />
                        <br />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/ctas/contexts' className={ style.tabOption }
                        data-active={ true }>Action Item Contexts</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allItem }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllCtaContextsTable
                            items={ items }
                            loadMore={ this.loadItems }
                            currentSort={ this.itemQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onItemUpdated={ this.itemUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getCtaContexts: ( itemQueryObject ) => {
            return dAPI.get( '/admin/cta/contexts', itemQueryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllCtaContextsView );
